import { useTranslation } from 'react-i18next';
import { PublicLayout } from '@scramble/layouts';
import { PublicFooter } from '@/components/PublicFooter';
import { saveUserLocale } from '@/helpers/locale';

export const PublicContainer = ({ children }) => {
  const { i18n } = useTranslation();

  const onChange = locale => {
    i18n.changeLanguage(locale)
    saveUserLocale(locale);
  };

  return (
    <PublicLayout
      currentLocale={i18n.language}
      onLocaleChange={onChange}
      footer={<PublicFooter />}
    >
      {children}
    </PublicLayout>
  );
};